import React, { Component } from "react";
import "./Layout/MainScreen.css";
import { Actions } from "jumpstate";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import SearchBox from "../Common/SearchBox/SearchBox";
import SwipeSlider from "../Common/SwipeSlider/SwipeSlider";
import TopHorseBox from "./TopHorseBox";
import getOS from "./../../utils/OSDetector";

class MainScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info: {
        horseCount: null,
        topHorses: null
      },
      showInstallAppAlert: false
    };

    this.closeInstallAppAlert = this.closeInstallAppAlert.bind(this);
  }

  componentDidMount() {
    Actions.mainInfo();

    this.setState({ showInstallAppAlert: getOS() === "Android" });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ info: nextProps.main });
  }

  closeInstallAppAlert() {
    this.setState({ showInstallAppAlert: false });
  }

  render() {
    const { info, showInstallAppAlert } = this.state;
    return showInstallAppAlert ? (
      <div id="installApp">
        <div className="container">
          <div
            className="exitWrapper"
            onClick={() => {
              this.closeInstallAppAlert();
            }}
          >
            <img
              className="btn-exit"
              src="https://static.iaho.ir/other/15840336255e6a6f59b19a8_z08e-18d.png"
            />
          </div>
          <div className="col-container">
            <a href="https://iaho.ir/" className="iaho-logo">
              <img
                alt="iaho"
                src="https://static.iaho.ir/other/15833284345e5facb27f21f_B0GLaGO_.png"
              />
            </a>
          </div>

          <div className="col-container help">
            <div className="help__head">اپلیکیشن اندروید آیاهو</div>
            <div className="download-group">
              <a className="btn" href="http://static.iaho.ir/iaho-0.8.apk">
                دانلود
              </a>
            </div>
            <div className="help__head2">راهنمای نصب</div>
            <p>در صورت اشکال در نصب از راهنمایی زیر استفاده کنید</p>
            <div className="help__container">
              <img src="https://static.iaho.ir/other/15833283165e5fac3c58af6_w7apcKCR.png" />
            </div>
          </div>
        </div>
      </div>
    ) : (
      <Grid id="searchbox">
        <Row>
          <Col xs={12}>
            <div id="logo">
              <span id="logo-large" className="retina sprite1 logolarge" />
              <span id="logo-small" className="retina sprite1 logosmall" />
            </div>
          </Col>
        </Row>
        <Row>
          <SearchBox />
        </Row>
        {info !== null && (
          <Row id="main-info">
            جستجو در میان <strong>{info.horseCount}</strong> اسب
          </Row>
        )}

        {info.topHorses && (
          <SwipeSlider>
            {info.topHorses.map((item, index) => (
              <TopHorseBox key={index} horse={item} />
            ))}
          </SwipeSlider>
        )}
      </Grid>
    );
  }
}

MainScreen.fetchData = () => Actions.mainInfo();

function mapStateToProps(state) {
  return {
    main: state.main
  };
}

export default connect(mapStateToProps)(MainScreen);



// WEBPACK FOOTER //
// ./src/components/Main/MainScreen.js